/*
=========================================================
Muse - Vue Ant Design Dashboard - v1.0.0
=========================================================

Product Page: https://www.creative-tim.com/product/vue-ant-design-dashboard
Copyright 2021 Creative Tim (https://www.creative-tim.com)
Coded by Creative Tim

=========================================================
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 
*/

import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
// import './plugins/click-away'

import './scss/app.scss';

// axios
import axios from 'axios'
import VueAxios from 'vue-axios'
import config from "./config.js"
// auth
import authService from './services/authService'
// moment
import moment from 'moment'
// vuex
import store from './store/index';
//v-form-builder
import FormBuilder from 'v-form-builder';
//excel
import JsonExcel from "vue-json-excel";
import * as XLSX from 'xlsx';

Vue.use(Antd);

Vue.prototype.XLSX = XLSX

// Vue.config.productionTip = false

// Configure axios
axios.defaults.baseURL = config.apiUrl
Vue.use(VueAxios, axios)

Vue.component("downloadExcel", JsonExcel);

Vue.component('FormBuilder', FormBuilder);

Vue.prototype.moment = moment

// pdf gen
// import VueHtmlToPaper from "vue-html-to-paper";
// const options = {
//   name: "_blank",
//   specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
//   styles: [
//     "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
//     // "https://unpkg.com/kidlat-css/css/kidlat.css",
//   ],
//   timeout: 1000, // default timeout before the print window appears
//   autoClose: true, // if false, the window will not close after printing
//   windowTitle: window.document.title, // override the window title
// };
// Vue.use(VueHtmlToPaper, options)

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

// token intercepter
function tokenInterceptor () {
  axios.interceptors.request.use(async config => {
    const token = await authService.getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      delete config.headers.Authorization
    }
    return config
  }, error => {
    return Promise.reject(error)
  })
}

async function bootstrap() {
  try {
    await authService.initialize()
    tokenInterceptor()
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  } catch (error) {
    console.error('Unable to initialize Microsoft authentication', error)
    const appElement = document.querySelector('#app')
    if (appElement) {
      appElement.textContent = 'Unable to initialize authentication. Please refresh the page.'
    }
  }
}

bootstrap()
